<template>
<div>
  <!-- 密码修改 -->
  <a-modal
    :title="$t('home.password_modification')"
    :keyboard="false"
    :maskClosable="false"
    :destroyOnClose="true"
    :closable="false"
    v-model="show"
    @cancel="cancelUpdatePassword"
    @ok="handleUpdatePassword">
    <a-form :form="form">
      <a-form-item
        :label="$t('home.old_password')"
        v-bind="formItemLayout">
        <a-input-password type="password"
                 autocomplete="false"
                 :placeholder="$t('ovarianReserve.enter') + $t('home.old_password')" v-decorator="['oldPassword',{rules: [{ required: true, message: $t('ovarianReserve.enter') + $t('home.old_password')}, { validator: this.handleOldPassowrd }], validateTrigger: ['blur']}]"></a-input-password>
      </a-form-item>
      <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['update-password', passwordLevelClass]">{{ ifZh ? '强度' : 'Strength' }}：<span>{{ passwordLevelName }}</span></div>
            <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor "/>
            <div style="margin-top: 10px;">
              <span>{{ $t('home.new_password_rule1') }}</span>
            </div>
          </div>
        </template>
        <a-form-item
          :label="$t('home.new_password')"
          v-bind="formItemLayout">
          <a-input-password type="password"
                   @click="handlePasswordInputClick"
                   autocomplete="false"
                   :placeholder="$t('home.new_password_rule')" v-decorator="['password',{rules: [{ required: true, message: $t('home.new_password_rule')}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"></a-input-password>
        </a-form-item>
      </a-popover>
      <a-form-item
        :label="$t('home.confirm_password')"
        v-bind="formItemLayout">
        <a-input-password type="password" autocomplete="false" :placeholder="$t('ovarianReserve.enter') + $t('home.confirm_password')" v-decorator="['password2',{rules: [{ required: true, message: $t('home.new_password_rule') }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"></a-input-password>
      </a-form-item>
    </a-form>
  </a-modal>
</div>
</template>
<script>
const ifZh = localStorage.getItem('language') ? localStorage.getItem('language').includes('zh') : true
const formItemLayout = {
  labelCol: { span: ifZh ? 4 : 8 },
  wrapperCol: { span: ifZh ? 18 : 16 }
}
const levelNames = {
  0: ifZh ? '低' : 'Low',
  1: ifZh ? '低' : 'Low',
  2: ifZh ? '中' : 'Medium',
  3: ifZh ? '强' : 'Strong'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}

export default {
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  props: {
    updatePasswordModelVisible: {
      default: false
    },
    user: {
      required: true
    }
  },
  data () {
    return {
      // form: null,
      formItemLayout,
      state: {
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      // oldPassword: '',
      // newPassword: '',
      validateStatus: '',
      help: '',
      ifZh
    }
  },
  computed: {
    show: {
      get: function () {
        return this.updatePasswordModelVisible
      },
      set: function () {
      }
    },
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    }
  },
  methods: {
    isMobile () {
      return this.$store.state.setting.isMobile
    },
    cancelUpdatePassword () {
      this.state.passwordLevelChecked = false
      this.form.resetFields()
      this.$emit('cancel')
    },
    handleUpdatePassword () {
      this.form.validateFields((err, values) => {
        if (!err) {
          let newPassword = this.form.getFieldValue('password')
          this.$put('user/password', {
            password: this.$aesEncrypt.encrypt(newPassword),
            username: this.user.username
          }).then(() => {
            this.state.passwordLevelChecked = false
            this.$emit('success')
            this.form.resetFields()
          })
        }
      })
    },
    handlePasswordLevel (rule, value, callback) {
      if (value && value.length < 8) {
        callback(new Error(this.$t('home.new_password_rule')))
      }
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[A-Z]/.test(value)) {
        level++
      }
      if (/[a-z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level > 2 ? 3 : level
      this.state.percent = level > 2 ? 100 : level * 30
      if (level > 2) {
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error(ifZh ? '密码强度不够' : 'Password strength is too low'))
      }
    },
    handlePasswordCheck (rule, value, callback) {
      let password = this.form.getFieldValue('password')
      if (value === undefined) {
        callback(new Error(this.$t('login.enter_password')))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error(ifZh ? '两次密码不一致' : 'The two passwords that you entered do not match'))
      }
      callback()
    },
    handlePasswordInputClick () {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    handleOldPassowrd (rule, value, callback) {
      let password = this.form.getFieldValue('oldPassword')
      if (typeof password !== 'undefined' && password.trim().length) {
        this.$get('user/password/check', {
          password: this.$aesEncrypt.encrypt(password),
          username: this.user.username
        }).then((r) => {
          if (r.data) {
            callback()
          } else {
            callback(new Error(ifZh ? '旧密码不正确' : 'Old password is incorrect'))
          }
        })
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang="less">
  .update-password {
    &.error {
      color: #ff0000;
    }
    &.warning {
      color: #ff7e05;
    }
    &.success {
      color: #52c41a;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/UpdatePassword.vue